var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiExclamationTriangle20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    part: "icon",
    id: "mi-exclamation-triangle",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.426 2.486A1 1 0 0 1 9.283 2h1.434a1 1 0 0 1 .858.486l7.191 11.985a1 1 0 0 1-.025 1.07l-.676 1.014a1 1 0 0 1-.832.445H2.768a1 1 0 0 1-.832-.445L1.26 15.54a1 1 0 0 1-.026-1.07L8.426 2.485zM10.717 3H9.283L2.092 14.986 2.768 16h14.465l.676-1.014L10.717 3zM9.5 11V7h1v4h-1zm-.25 1.5h1.5V14h-1.5v-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiExclamationTriangle20Px);
export default __webpack_public_path__ + "static/media/mi-exclamation-triangle-20px.bba1c2535f6f8b4f5f6fff624c039d3d.svg";
export { ForwardRef as ReactComponent };